"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaultMessages = {
  new: 'New',
  nlp: 'New lower price',
  family: 'IKEA Family price'
};
const CommercialMessage = props => {
  const {
    prefix = '',
    message,
    variant = 'new',
    subtle,
    className
  } = props;
  const cssStyles = (0, _classnames.default)(className, `${prefix}commercial-message`, subtle && `${prefix}commercial-message--subtle`, `${prefix}commercial-message${subtle ? '--subtle' : ''}--${variant}`);
  return _react.default.createElement("div", {
    className: cssStyles
  }, _react.default.createElement("span", {
    className: `${prefix}commercial-message__title`
  }, message || defaultMessages[variant]));
};
var _default = CommercialMessage;
exports.default = _default;